import { createContext, useContext } from 'react'

/**
 * Сигнализирует, что страница уже отрисована внутри `UnvLayout`/`Layout`.
 * Нужно, чтобы вложенный `Layout` (если страница сама обернулась в него)
 * не рендерил второй sidebar — а просто пропускал `children` дальше.
 */
export const LayoutContext = createContext({ inLayout: false })

export const useInLayout = () => useContext(LayoutContext).inLayout
